export const LOAD_HB_INDEX_CHART_DATA_REQUEST = "[HB INDEX CHART] LOAD_HB_INDEX_CHART_DATA_REQUEST";
export const LOAD_HB_INDEX_CHART_DATA_SUCCESS = "[HB INDEX CHART] LOAD_HB_INDEX_CHART_DATA_SUCCESS";
export const LOAD_HB_INDEX_CHART_DATA_ERROR = "[HB INDEX CHART] LOAD_HB_INDEX_CHART_DATA_ERROR";
export const CHANGE_RADIO = "[HB INDEX CHART] CHANGE_RADIO";



export const loadHbIndexChartDataRequest = () => ({ type: LOAD_HB_INDEX_CHART_DATA_REQUEST });
export const loadHbIndexChartDataSuccess = ({ data, radio, selectedRadio }) => (
  { type: LOAD_HB_INDEX_CHART_DATA_SUCCESS, data, radio, selectedRadio }
  );
export const loadHbIndexChartDataError = error => ({ type: LOAD_HB_INDEX_CHART_DATA_ERROR, error });

export const changeRadio = radio => ({ type: CHANGE_RADIO, radio });

export const CLEAR_DATA = "[HB INDEX CHART] CLEAR DATA";
export const clearData = () => ({ type: CLEAR_DATA});


// WEBPACK FOOTER //
// ./src/modules/hb-index-chart/hb-index-chart-action-creators.js